import { render } from "./FooterElement.vue?vue&type=template&id=4b9ebf36&scoped=true"
const script = {}

import "./FooterElement.vue?vue&type=style&index=0&id=4b9ebf36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b9ebf36"]])

export default __exports__